// import React from 'react';
// import { Container, Row, Col } from 'react-bs-grid';
// import { Link } from 'react-router-dom';

export default () => null;
// (
//   <div className="bg-dark footer">
//     <Container fluid>
//       <Row>
//         <Col sm={12}>
//           <ul className="list-inline">
//             <li>
//               <Link to="/about">About</Link>
//             </li>
//             <li>
//               <a href="http://eepurl.com/RkmNn" target="_blank">Subscribe</a>
//             </li>
//           </ul>
//         </Col>
//       </Row>
//     </Container>
//   </div>
// );



// WEBPACK FOOTER //
// ./src/components/footer.js